import type { BoundApi } from '@/core/api/createApi'
import { api } from '@/core/api/request'
import { logger } from '@/core/app/logger'
import { OcrScanRequestGetResponseSchema } from '@/schemas/v2'
import type { OcrScanRequest, OcrScanRequestGetResponse } from '@/schemas/v2'

const BASE = process.env.NEXT_PUBLIC_API_URL ?? ''

type FetchOptions = { headers?: Record<string, string> }

/**
 * OCR 補填申請フォーム設定取得 (v2)
 * GET /api/v2/ocr/scan/request/{ocrId}
 */
export async function fetchOcrScanRequest(ocrId: number, options?: FetchOptions): Promise<OcrScanRequestGetResponse> {
  const url = `${BASE}/api/v2/ocr/scan/request/${ocrId}`
  logger.info({ fetch_method: 'GET', fetch_url: url, msg: 'OCR 補填申請設定 fetch 開始' })
  try {
    const data = await api.get<unknown>(url, options)
    return OcrScanRequestGetResponseSchema.parse(data)
  } catch (e) {
    logger.error({ fetch_method: 'GET', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

/**
 * OCR 補填申請 (v2)
 * POST /api/v2/ocr/scan/request
 */
export async function postOcrScanRequest(body: OcrScanRequest, options?: FetchOptions): Promise<void> {
  const url = `${BASE}/api/v2/ocr/scan/request`
  logger.info({ fetch_method: 'POST', fetch_url: url, msg: 'OCR 補填申請 fetch 開始' })
  try {
    await api.post<void>(url, body, options)
  } catch (e) {
    logger.error({ fetch_method: 'POST', fetch_url: url, msg: `fetch エラー: ${String(e)}` })
    throw e
  }
}

/**
 * OCR補填申請フォーム設定取得の TanStack Query オプション。
 * 失敗ダイアログ（状態機械の fetchQuery）と /ocrForm の useQuery で同一 queryKey を共有し、
 * 二重フェッチを避ける。staleTime を持たせて、遷移直後の /ocrForm マウント時に
 * 失敗ダイアログの取得結果をそのまま再利用する（0 だと即 stale となり再フェッチが走る）。
 */
export const OCR_SCAN_REQUEST_STALE_TIME = 30_000

export const ocrScanRequestQueryOptions = (ocrId: number, boundApi: BoundApi) => ({
  queryKey: ['ocrScanRequest', ocrId] as const,
  queryFn: () => boundApi.auth.fetchOcrScanRequest(ocrId),
  staleTime: OCR_SCAN_REQUEST_STALE_TIME,
})
